export default function NewsMS4StormWaterUpdate() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#collapseNewsMS4StormWaterUpdate">
            <div className="custom-button-layout">
            <i className="fa-solid fa-cloud-showers-water fa-2xl feature-icon af-icon"></i>
            <b>2026 NPDES MS4 Program Update&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
            <span className="badge bg-secondary badge-custom">STORMWATER</span>
            </div>
          </button>
        </h2>
        <div id="collapseNewsMS4StormWaterUpdate" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
          <div className="accordion-body">
    <p>
            The 2026 NPDES MS4 Program Updates presentation, prepared by Borough Engineer Jacob Rigg, P.E., is available for public review.
</p>
            <a href="../docs/stormwater/2026_MS4_Program_Updates.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2026 MS4 Program Updates
          </a>
          </div>
        </div>
      </div>
    )
}